(function () {
  function initSection(root) {
    if (!root || root.dataset.yhCollectionInit === 'true') return;

    var track = root.querySelector('[data-yh-collection-track]');
    if (!track) return;

    root.dataset.yhCollectionInit = 'true';

    var cards = Array.from(root.querySelectorAll('.collection-list__item'));
    var prevBtn = root.querySelector('[data-yh-collection-prev]');
    var nextBtn = root.querySelector('[data-yh-collection-next]');

    function updateNav() {
      var max = track.scrollWidth - track.clientWidth;
      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 1;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= max - 1;
    }

    function scrollByCard(direction) {
      var card = cards[0];
      if (!card) return;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      track.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
    }

    updateNav();

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(updateNav);
    });

    /* Drag to scroll — desktop only; mobile uses swipe + nav buttons */
    var isDown = false;
    var startX = 0;
    var scrollLeft = 0;
    var moved = false;
    var mq = window.matchMedia('(min-width: 750px)');

    track.addEventListener('pointerdown', function (e) {
      if (!mq.matches) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.target.closest('button, a')) return;
      isDown = true;
      moved = false;
      startX = e.clientX;
      scrollLeft = track.scrollLeft;
      track.classList.add('is-dragging');
      try {
        track.setPointerCapture(e.pointerId);
      } catch (err) {}
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDown || !mq.matches) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = scrollLeft - dx;
    });

    function endDrag(e) {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-dragging');
      try {
        track.releasePointerCapture(e.pointerId);
      } catch (err) {}
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener(
      'click',
      function (e) {
        if (moved && mq.matches) {
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        }
      },
      true
    );
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('.yh-collection-list').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) {
      var section = event.target.querySelector('.yh-collection-list') || event.target;
      if (section && section.classList && section.classList.contains('yh-collection-list')) {
        section.dataset.yhCollectionInit = '';
        initSection(section);
      } else {
        initAll(event.target);
      }
    }
  });
})();
